import { mockActivities } from '../data/mockData';

const STORAGE_KEY = 'safeguardpro_activities';

export default class ActivityService {
  list() {
    if (typeof window === 'undefined') return mockActivities;
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(mockActivities));
        return mockActivities;
      }
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length) return parsed;
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(mockActivities));
      return mockActivities;
    } catch (error) {
      return mockActivities;
    }
  }

  save(activities) {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(activities));
  }

  add(activity) {
    const next = [...this.list(), activity];
    this.save(next);
    return next;
  }

  update(activity) {
    const next = this.list().map((item) => (item.id === activity.id ? activity : item));
    this.save(next);
    return next;
  }
}
